import React, { useState, useEffect } from "react";

import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
  Spinner,
} from "reactstrap";
import { useLocation } from "react-router-dom";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../components/Paginationv3";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
//componentes
import ModalNewConfigRanking from "./modalNewConfigRanking";
import ModalEditConfigRanking from "./modalEditConfigRanking";
import ConfigColorRanking from "./modalConfigColorRankink";
import useDebounce from "../../../utils/hooks/useDebounce";
import SearchFilters from "../../../components/SearchFilters";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import WaitExport from "../../../components/WaitExport";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
// xlsx
import { createXlsx } from "./createXlsxConfig";
//service
import {
  getConfigurations,
  deleteConfiguration,
  deleteAllConfiguration,
} from "../../../utils/services/ranking";
// utils
import { optionCode } from "./mockCodes";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ModalImportConfig from "./ModalImportConfig";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

function Ranking(props) {
  const location = useLocation();
  //state do modal
  const [modalNewConfig, setModalNewConfig] = useState(false);
  const [modalEditConfig, setModalEditConfig] = useState(false);
  const [modalColor, setModalColor] = useState(false);
  const [modalImportConfig, setModalImportConfig] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  //state de pesquisa
  const [search, setSearch] = useState("");
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  //dados da listagem
  const [config, setConfig] = useState([]);
  //state editar config
  const [editConfig, setEditConfig] = useState();
  //state deletar config
  const [confirm_alert, setconfirm_alert] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [deleteConfig, setDeleteConfig] = useState();
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  // exportar
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  const debouncedSearch = useDebounce(search, 300);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("code");

  const [loadingDelete, setLoadingDelete] = useState(false);
  const [errorOnDeleteAll, setErrorOnDeleteAll] = useState(false);
  // state de carregamento da tabela
  const [loading, setLoading] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  // ids e token
  const idEvent = location.state.idEvent;
  const token = props.state.global_user_data.data.token;

  const columnsFilter = [
    { name: "Código", value: "code", type: "text" },
    { name: "Pontuação", value: "point", type: "text" },
  ];

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }
  function toggleModalNewConfig() {
    setModalNewConfig(!modalNewConfig);
  }

  function toggleModalEditConfig() {
    setModalEditConfig(!modalEditConfig);
  }

  function toggleModalColor() {
    setModalColor(!modalColor);
  }

  function formatData(startDate) {
    return startDate.substr(0, 10);
  }

  async function deleteConfigFunc() {
    await deleteConfiguration(deleteConfig.id, token).then((response) => {
      if (response.message === "CONFIGURATION_DISABLED") {
        setconfirm_alert(false);
        setsuccess_dlg(true);
        setdynamic_title("Sucesso");
        setdynamic_description("Configuração de ranking deletada com sucesso");
        getAllConfigurations();
      }
    });
    // .catch((error) => console.log("response error", error));
  }

  async function confirmDeleteAllConfigurations() {
    setLoadingDelete(true);
    await deleteAllConfiguration(idEvent).then((response) => {
      if (response.message === "deleted") {
        setLoadingDelete(false);
        setsuccess_dlg(true);
        setdynamic_title("Sucesso");
        setdynamic_description("Configurações de ranking deletadas com sucesso");
        setErrorOnDeleteAll(false);
      } else {
        setdynamic_title("Erro");
        setdynamic_description(
          "Ocorreu um erro ao deletar os Códigos, eles estão sendo usadas no ranking",
        );
        setLoadingDelete(false);
        setErrorOnDeleteAll(true);
        setsuccess_dlg(true);
      }
      getAllConfigurations();
    });
  }
  async function getAllConfigurations() {
    setLoading(true);
    await getConfigurations({
      id: idEvent,
      jwt: token,
      offset: currentIndex > 0 ? currentIndex : 1,
      limit: itemsPerPage,
      search: treatmentSearch(),
      columnSearch: activeFilter,
    })
      .then((response) => {
        setConfig(response.data);
        setCountData(response.count);
      })
      .catch((error) => {
        // console.log("response error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function getXlsx() {
    createXlsx({
      jwt: token,
      eventId: idEvent,
      limit: 500,
      totalItems: countData,
      setFinishExport,
    }) > setExportInProgress(true);
  }

  useEffect(() => {
    getAllConfigurations();
  }, [currentIndex, itemsPerPage, debouncedSearch]);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Configurações do Ranking"
          onConfirm={confirmDeleteAllConfigurations}
        />
      )}

      <WaitExport
        isOpen={exportInProgress}
        name="Relatório de Configurações"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />

      {modalNewConfig && (
        <ModalNewConfigRanking
          isOpen={modalNewConfig}
          toggle={toggleModalNewConfig}
          jwt={token}
          idEvent={idEvent}
          getAllConfigurations={getAllConfigurations}
        />
      )}

      {modalEditConfig && (
        <ModalEditConfigRanking
          isOpen={modalEditConfig}
          toggle={toggleModalEditConfig}
          jwt={token}
          idEvent={idEvent}
          getAllConfigurations={getAllConfigurations}
          editConfig={editConfig}
        />
      )}

      {modalColor && (
        <ConfigColorRanking isOpen={modalColor} toggle={toggleModalColor} />
      )}

      {modalImportConfig && (
        <ModalImportConfig
          isOpen={modalImportConfig}
          toggle={() => setModalImportConfig(false)}
          idEvent={idEvent}
          token={token}
          getAllConfigurations={getAllConfigurations}
        />
      )}

      {confirm_alert ? (
        <SweetAlert
          title={`Deseja deletar ${
            optionCode.find((a) => a.code === deleteConfig.code)?.describe ||
            deleteConfig.code
          } ?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            deleteConfigFunc();
          }}
          onCancel={() => setconfirm_alert(false)}
        >
          <span>Você não poderá reverter essa ação!</span>
        </SweetAlert>
      ) : null}

      {success_dlg ? (
        <SweetAlert
          // success
          success={!errorOnDeleteAll}
          error={errorOnDeleteAll}
          title={dynamic_title}
          onConfirm={() => {
            setsuccess_dlg(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}

      <Card>
        <CardBody>
          <CardTitle>Configurações</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                {config.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div onClick={() => getXlsx()}>Exportar Configuração</div>
                  </Row>
                )}

                <ActionButtonRounded
                  title="Importar Configuração"
                  onClick={() => setModalImportConfig(true)}
                  type="mobile"
                />

                <ActionButtonRounded
                  title="Adicionar Configuração"
                  onClick={() => setModalNewConfig(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              {config.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => getXlsx()}
                >
                  Exportar Configuração
                </Button>
              )}

              <ActionButtonRounded
                title="Importar Configuração"
                onClick={() => setModalImportConfig(true)}
                margin={"0 5px"}
              />

              <ActionButtonRounded
                title="Adicionar Configuração"
                onClick={() => setModalNewConfig(true)}
              />

              {/* <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                onClick={() => setModalColor(true)}
                style={{ marginLeft: 10 }}
              >
                Configurações de cor do Ranking
              </Button> */}
            </div>
          </div>
          <div className="table-responsive">
            <Table>
              <thead className="table-light">
                <tr>
                  <th>Código</th>
                  <th>Icone</th>
                  <th>Pontuação</th>
                  <th>Diário</th>
                  <th>Data Inicio</th>
                  <th>Hora Inicio</th>
                  <th>Data Fim</th>
                  <th>Hora Fim</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={9} />
                ) : (
                  config?.length > 0 &&
                  config?.map((e, i) => (
                    <tr key={e.code}>
                      <td>
                        {/* {optionCode.find((f) => f.code === e.code)?.describe ||
                          e.code} */}
                        {e.code}
                      </td>
                      <td>
                        <i className={e.urlIcon} />
                      </td>
                      <td>{e.earnedPoints}</td>
                      <td>{e.daily ? "Sim" : "Não"}</td>
                      <td>
                        {e.daily
                          ? formatData(e.startAt).split("-").reverse().join("/")
                          : null}
                      </td>
                      <td>{e.startHour}</td>
                      <td>
                        {e.daily
                          ? formatData(e.endAt).split("-").reverse().join("/")
                          : null}
                      </td>
                      <td>{e.endHour}</td>
                      <td>
                        <i
                          className="mdi mdi-pencil"
                          style={{
                            color: "green",
                            fontSize: 17,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setEditConfig(e);
                            setModalEditConfig(true);
                          }}
                        />{" "}
                        <DeleteButton
                          onClick={() => {
                            setDeleteConfig(e);
                            setconfirm_alert(true);
                          }}
                          color="red"
                          fontSize={17}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            config?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {config?.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Códigos"
            action="D"
            color="danger"
            className="btn-rounded waves-effect waves-light events-button-add-lg"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        <Pagination
          data={config}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Ranking);
